"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FlagUY = function FlagUY(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "411.6",
    height: "270.36",
    viewBox: "0 0 411.6 270.36"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M209.54-122H-185.94a7.06,7.06,0,0,0-7.06,7.06V139.3a7.06,7.06,0,0,0,7.06,7.06H209.54a7.06,7.06,0,0,0,7.06-7.06V-114.94a7.06,7.06,0,0,0-7.06-7.06Zm0,0",
    transform: "translate(194 123)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "149.3",
    y: "30.82",
    width: "261.3",
    height: "29.82",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "60.64",
    width: "409.6",
    height: "29.82",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "149.3",
    y: "90.45",
    width: "261.3",
    height: "29.81",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "120.27",
    width: "409.6",
    height: "29.82",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "150.09",
    width: "409.6",
    height: "29.81",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "179.91",
    width: "409.6",
    height: "29.82",
    fill: "#f5f5f5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "209.72",
    width: "409.6",
    height: "29.82",
    fill: "#4173cd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-141.82-103.31-130-48.64l18.48-7.66Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-141.82-103.31l21.06,50.84L-130-48.64Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-95.88,7.61-107.69-47l-18.49,7.65Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-95.88,7.61l-21.05-50.84,9.24-3.82Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-63.39-70.82-118.06-59l7.66,18.48Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-63.39-70.82l-50.84,21.06L-118.06-59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-174.3-24.88l54.66-11.81-7.66-18.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-174.3-24.88l50.83-21,3.83,9.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-95.88-103.31l-30.3,47,18.49,7.66Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-95.88-103.31l-21.05,50.84-9.25-3.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-141.82,7.61l30.3-47L-130-47Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-141.82,7.61l21.06-50.84,9.24,3.83Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-63.39-24.88l-47-30.3-7.66,18.49Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-63.39-24.88l-50.84-21,3.83-9.25Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-174.3-70.82l47,30.3L-119.64-59Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-174.3-70.82l50.83,21.06-3.83,9.24Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85-107.87l-10,55h20Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85-107.87v55h-10Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18l10-55h-20Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-118.85,12.18v-55h10Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-58.82-47.85l-55-10v20Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-58.82-47.85h-55v-10Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-178.88-47.85l55,10v-20Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-178.88-47.85h55v10Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.4-90.29l-46,31.83,14.15,14.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.4-90.29l-38.91,38.9-7.08-7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-161.29-5.4l46-31.84-14.15-14.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-161.29-5.4l38.9-38.91,7.08,7.07Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.4-5.4l-31.84-46-14.15,14.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-76.4-5.4l-38.91-38.91,7.07-7.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-161.29-90.29l31.83,46,14.15-14.15Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-161.29-90.29l38.9,38.9-7.07,7.08Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffcd5a"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-98.84-47.84a20,20,0,0,1-20,20,20,20,0,0,1-20-20,20,20,0,0,1,20-20,20,20,0,0,1,20,20Zm0,0",
    transform: "translate(194 123)",
    fill: "#ffe15a"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "1",
    y: "1",
    width: "409.6",
    height: "268.36",
    rx: "7",
    ry: "7",
    fill: "none"
  }));
};

var _default = FlagUY;
exports["default"] = _default;